<template>
  <div class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" ref="modal">
    <div class="photo-modal modal-dialog modal-lg" role="document" >
      <div class="modal-content">
        <!-- Header -->
        <div class="modal-header border-bottom-0 py-1 relative-position">
          <h5 class="photo-no modal-title text-center w-100" >{{targetPhoto.photo_no}}</h5>
          <img class="btn-close-mg" data-dismiss="modal" src="~assets/close_btn.png">

          <!--<button type="button" class="btn-close rounded-circle" data-dismiss="modal" aria-label="Close">-->
            <!--<i class="fa fa-times" aria-hidden="true"></i>-->
          <!--</button>-->
        </div>
        <!-- 縦長画像 -->
        <!-- 画像 -->
        <div class="modal-body px-1 pt-0 pb-3">
          <div class="row mx-1-gutters">
            <div class="col">
              <div class="photo-image-area" ref="imageAreaFrame">
                <div class="photo-image-wrap h-100 w-100 relative-position" ref="imageAreaWrap" style="position:relative;">
                  <!--<img class="photo-image img-fluid" ref="imageArea" v-lazy="bigThumbnailUrl" >-->
                    <img class="photo-image" ref="imageArea" v-lazy="photoImageUrl" >
                </div>
              </div>
            </div>
            <!-- 縦長時の操作UI -->
            <div class="col-4 vertical-operation-flex-wrap" v-if="isVertically" >
              <div class="d-flex flex-column justify-content-end h-100 vertical-operation-flex">
                <div class="text-center pb-3">
                </div>
                <div class="clearfix">
                  <button type="button" class="p-0 btn float-left" style="background-color: transparent; color:#82ba1d;" @click="prevImage"><i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i></button>
                  <button type="button" class="p-0 btn float-right" style="background-color: transparent; color:#82ba1d;" @click="nextImage"><i class="fa fa-arrow-right fa-2x" aria-hidden="true"></i></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 横長時の操作UI -->
        <div class="modal-footer border-top-0 pt-0" v-if="!isVertically">
          <div class="text-left">
            <button type="button" class="btn p-0" style="background-color: transparent; color:#82ba1d;" @click="prevImage"><i class="fa fa-arrow-left fa-2x" aria-hidden="true"></i></button>
          </div>
          <div class="text-center">
          </div>
          <div class="text-right">
            <button type="button" class="btn p-0" style="background-color: transparent; color:#82ba1d;" @click="nextImage"><i class="fa fa-arrow-right fa-2x" aria-hidden="true"></i></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import Hammer from 'hammerjs'

  export default {
    props: {
      targetPhoto: {},
      targetPhotoSize:{},
    },
    components: {
    },
    data () {
      return {
        imageOperation:{
          adjustScale:1,
          adjustDeltaX:0,
          adjustDeltaY:0
        }
      }
    },
    watch:{
    },
    computed:{
      photoImageUrl(){
        let photo = this.targetPhoto
        if(!photo.id){ return '/dist/lodding.gif' }
        //dd(photo)

        if(!photo){ return null }

        //dd("A1",this.targetPhotoSize.code);
        let photoImage = app.make("_").find(photo.photo_images,(photo_image)=>{

          //dd("Z",photo_image.photo_size);
          //return (String(photo_image.type_code) === "1") //String(this.targetPhotoSize.code))
          return (String(photo_image.photo_size.code) === String(this.targetPhotoSize.code)) //String(this.targetPhotoSize.code))

        })
        return photoImage.image_url + '?token='+store.get("token")
      },
      bigThumbnailUrl(){
        let photo = this.targetPhoto
        if(!photo.id){ return '/dist/lodding.gif' }
        //if(!photo.id){ return '/dist/lodding.gif?'+ (new Date()).getTime() }
        let photoThumbnail = app.make("_").find(photo.photo_thumbnails,(photo_thumbnail)=>{
          return (String(photo_thumbnail.type_code) === this.targetPhotoSize.code)
        })
        //dd("TYPE",photoThumbnail)

        return photoThumbnail.image_url + '?token='+store.get("token")
      },
      borderClass(){
        return this.isFavorited? "redBorder" : "grayBorder"
      },
      isFavorited(){
        return !app.make("_").isEmpty(this.targetPhoto.cart_photos);
      },
      isVertically(){
        let photo = this.targetPhoto
        if(!photo.id){ return null }
        return app.make("_").first(photo.photo_thumbnails).is_vertically || 0
      },
    },
    mounted(){
      this.$nextTick(()=> {
      })


    },
    methods:{
      prevImage(){
        this.$emit("prevImage",this.targetPhoto)

        let webpage = this.$refs.imageAreaWrap
        let transforms = [];
        transforms.push('scale(1)');
        transforms.push('translate(0,0)');
        webpage.style.transform = transforms.join(' ');
        this.imageOperation.adjustScale = 1;
        this.imageOperation.adjustDeltaX = 0;
        this.imageOperation.adjustDeltaY = 0;
      },
      nextImage(){
        this.$emit("nextImage",this.targetPhoto)

        let webpage = this.$refs.imageAreaWrap
        let transforms = [];
        transforms.push('scale(1)');
        transforms.push('translate(0,0)');
        webpage.style.transform = transforms.join(' ');
        this.imageOperation.adjustScale = 1;
        this.imageOperation.adjustDeltaX = 0;
        this.imageOperation.adjustDeltaY = 0;

      },
      addCart(){
        this.$emit("addCarPhoto",this.targetPhoto)
      },
      removeCart(){
        this.$emit("removeCartPhoto",this.targetPhoto)
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "~scss/_variables";


  .vertical-operation-flex-wrap{
    position: relative;
    .vertical-operation-flex{
      position: absolute; top:0; left:0; bottom: 0; right:0; width:100%; height:100%;
    }

  }

  .btn-favolite{
    @media(max-width: map-get($grid-breakpoints, "lg") - 1) {
      font-size: .6rem !important;
    }
  }

  .modal-footer > div{
    flex-grow: 1;
  }
  .photo-modal{
    .photo-no{
      font-size:1.0rem;
    }
    .photo-image-area{
      overflow:hidden;
      position: relative;
      .photo-image-wrap{
        transform: translate3d(0,0,0);
        transition: transform 0.1s;
        transition-timing-function: ease-in-out;
        transition-property: transform;
        .photo-image{
          max-width: 100%;
          max-height: 80vh;
        }
      }
    }

    .btn-close-mg{
      z-index: 1200;
      cursor: pointer;
      width:48px;
      height:48px;
      margin-top: -12px;
      margin-right: -24px;
      @media(min-width: map-get($grid-breakpoints, "lg")) {
        width:64px;
        height:64px;
        margin-top: -16px;
        margin-right: -32px;
      }

    }
    .btn-close{
      background-color: #909090;
      color: #ffffff;
      margin-top: -32px + 4;
      margin-right: -32px;
      width:48px;
      height:48px;
      z-index: 2000;
      position: relative;
      border: none;
      font-size: 2rem;
      font-weight: bold;
      line-height: 1;
      text-shadow: 0 1px 0 #fff;
      cursor: pointer;
    }
  }

</style>



// WEBPACK FOOTER //
// OrderDownloadPhotoImageModal.vue?4559e0c6